import dynamic from "next/dynamic";

import { useI18n } from "utils/with-i18n.utils";

import animation from "./lesaviez-vous.json";

const Lottie = dynamic(() => import("react-lottie-player"));

export const Banner = () => {
  const i18n = useI18n();

  return (
    <div className="flex overflow-x-clip relative mt-6 sm:mb-20">
      <section
        className="absolute top-0 left-1/2 z-50 py-12 px-14 bg-pastel-green-2 lg:px-5"
        style={{
          transform: "rotate(-2.54deg) translateX(-50%)",
          width: "calc(100vw + 100px)",
        }}
      >
        <div className="flex relative gap-6 justify-center items-center mx-auto w-full max-w-[1800px] h-full lg:px-32 2xl:px-[15rem]">
          <Lottie
            animationData={animation}
            loop
            play
            className="absolute top-[-110px] left-1/2 w-[150px] h-[150px] translate-x-[-50%] lg:static lg:w-auto lg:h-auto lg:translate-x-0 2xl:w-[500px]"
          />
          <article className="flex flex-col pt-[30px] lg:pt-0">
            <span
              className="before:absolute relative before:top-[2px] before:left-[2px] before:-z-10 text-[24px] font-black leading-[30px] text-center text-white before:text-black lg:text-[42px] lg:leading-[55px] lg:text-left"
              style={{
                textShadow:
                  "1px 0 black, 0px 1px black, -1px 0 black, 0 -1px black, 2px 2px black, 1px 1px black, 1.5px 1.5px black, 2.5px 2.5px black, 3px 3px black, 3.5px 3.5px black",
              }}
            >
              {i18n.t("environment.banner.html", {}, { html: true })}
            </span>
          </article>
        </div>
      </section>
      <section
        className="invisible py-12 px-14 bg-pastel-green-2 md:px-28"
        style={{
          transform: "rotate(-2.54deg)",
          width: "calc(100vw + 100px)",
        }}
      >
        <div className="flex relative gap-6 items-center w-full h-full">
          <Lottie
            animationData={animation}
            loop
            play
            className="absolute top-[-190px] left-1/2 w-[250px] h-[250px] translate-x-[-50%] lg:static lg:w-auto lg:h-auto lg:translate-x-0"
          />
          <article className="flex flex-col pt-[55px] lg:pt-0">
            <span className="relative text-[24px] font-black leading-[30px] text-center text-black lg:text-[42px] lg:leading-[55px] lg:text-left">
              {i18n.t("environment.banner.text")}{" "}
              <span className="absolute right-1 bottom-1 w-full text-white">
                {i18n.t("environment.banner.html", {}, { html: true })}{" "}
              </span>
            </span>
          </article>
        </div>
      </section>
    </div>
  );
};
